import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { isDefined } from '@/utils/miscUtils';

const Select = ({
  name,
  options,
  defaultValue,
  onChange,
  className = '',
  bordered = true,
  registerOptions = {},
  disabled = false,
}) => {
  const { register } = useFormContext();
  const sizeClass = className.match('select-') ? '' : 'select-xs';
  const selectProps = onChange ? { onChange } : {};
  const inputType = bordered ? 'select-bordered' : '';

  return (
    <select
      id={name}
      name={name}
      {...(isDefined(defaultValue) && { defaultValue })}
      {...register(name, registerOptions)}
      {...selectProps}
      disabled={disabled}
      className={`select ${sizeClass} ${inputType} ${className} ${disabled ? 'select-disabled' : ''}`}
    >
      {options?.map((option, index) => (
        <option key={`${index}-${option.value ?? option}`} value={option.value ?? option}>
          {option.label ?? option}
        </option>
      ))}
    </select>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.any),
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  onChange: PropTypes.func,
  bordered: PropTypes.bool,
  registerOptions: PropTypes.object,
  disabled: PropTypes.bool,
};

export default Select;
